module.exports={
  "Flat Guarantee": "Flat Guarantee",
  "vs Net Profit": "vs % Net Profit"
}
